import { render, staticRenderFns } from "./createPdv.vue?vue&type=template&id=588c678d&scoped=true&"
import script from "./createPdv.vue?vue&type=script&lang=js&"
export * from "./createPdv.vue?vue&type=script&lang=js&"
import style0 from "./createPdv.vue?vue&type=style&index=0&id=588c678d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588c678d",
  null
  
)

export default component.exports